import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '../pages/user/stores/user'
import { useNavigationStore } from '../stores/navigation'

import UserRoutes from './user'
import AdminRoutes from './admin'
import PartAdminRoutes from './partadmin'
import SyadminRoutes from './sysadmin'

import NotFoundView from '../pages/NotFound.vue'

import http from "@/api/http";

// 버전확인 api 조회
function checkVersion() {
  return http.post(`system/deploy/retrieve`, {deployId:1});
}


const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    ...UserRoutes,
    ...AdminRoutes,
    ...PartAdminRoutes,
    ...SyadminRoutes,
    {
      path: "/404",
      name: "NotFound",
      component: NotFoundView,
    },
    {
      path: "/:pathMatch(.*)*",
      redirect: "/404",
    },
  ]
})


const public_pages = [
    "Home",
  "AboutCompany",
  "AboutDirector",
  "AboutWithus",
  "AboutHistory",
  "Signin",
  "SigninSearchID",
  "SigninSearchIDComplete",
  "SigninSearchPW",
  "SigninSearchPWReset",
  "SigninJoinCertify",
  "SigninJoinMemberType",
  "SigninJoinTerms",
  "SigninJoinMemberInfoStudent",
  "SigninJoinComplete",
  "SignupCertify",
  "SignupMemberType",
  "SignupTerms",
  "SignupMemberInfo",
  "SignupComplete",
  "LectureCurriculum",
  "LectureOfflineList",
  "LectureOnlineList",
  "LectureOnlineDetail",
  "LectureOfflineDetail",
  "SLectureOfflineDetail",
  "CreditAcceptableLecture",
  "MatchingJob",
  "MatchingJobFairList",
  "MatchingJobFairDetail",
  "SMatchingJobFairDetail",
  "InsightsNotify",
  "InsightsNotifyDetail",
  "InsightsFAQ",
  "InsightsQNA",
  "InsightsQNADetail",
  "InsightsNewsletter",
  "InsightsNewsletterDetail",
  // "MyPageRecord",
  // "MyPageResume",
  // "MyPageLecture",
  // "MyPageLectureCertificate",
  // "MyPageLecturePDFViewer",
  // "MyPageLectureDetail",
  // "MyPageMyClass",
  // "MyPageMyClassDetail",
  // "MypageProposalListView",
  // "MypageProposalCreateView",
  // "MypageProposalUserListView",
  // "MypageResumeCorporation",
  // "MypageSearchResume",
  // "MypageResumeLike",
  // "UserMatchingResumeProposalList",
  // "UserMatchingResume",
  // "UserMatchingResumeProposalDetail",
  // "UserProposalUser",
  // "MyPageJobFair",
  // "MyPageJobFairDetail",
  // "MyPageJobFairResume",
  "MyPageJobFairResumeCreate",
  "MyPageJobFairEntry",
  // "MyPageCorpJobFair",
  // "MyPageCorpJobFairDetail",
  "MyPageCorpJobNoticeCreat",
  // "MyPageCorpJobNotice",
  "MyPageCorpRecruitmentHall",
  // "MyPageProfile",
  // "MyPageProfilePWReset",
  // "MyPageProfileWithdraw",
  // "MyPageUserGbHistory",
  // "MypageUserGbHistoryCreate",
  // "EmailUnsubscribe",
  // "personal",
  // "emailRejection",
];

router.beforeEach(async (to, from, next) => {
  const { isAdmin, isPartAdmin, isAuthenticated } = useUserStore();
  const userStore = useUserStore();
  const navigationStore = useNavigationStore();

  if(['Signup', 'Signin', 'SigninAdmin', 'SigninPartAdmin', 'SigninSysAdmin'].indexOf(to.name) > -1) {
    userStore.setUser({});
  }

  let reloadFlag = false;
  try {
    // 특별재용관 버전 체크
    if(public_pages.indexOf(to.name) > -1) {
      // alert('버전이 다름 새로고침')
      // 1. 버전 불러오기
      const currentVersion = sessionStorage.getItem('version');

      // 2. 버전 체크 (현재 버전과 비교)
      const result = await checkVersion();

      // 문자열 저장
      sessionStorage.setItem("version", result.data.result.frontVersion);

      // 3. 버전이 다르면 새로고침(강제로)
      if (currentVersion && result.data.result.frontVersion !== currentVersion) {
        // window.location.reload()
        sessionStorage.removeItem("systemCodeValues"); // 코드값 강제 업데이트위한 삭제처리 26.06.09
        reloadFlag = true;
      }
    }
  }catch (error) {

  }

  // router관리하는 js 파일에서 meta 에 해당 항목들 true, false 처리
  if(to.matched.some((record) => record.meta.admin)) { // 관리자 페이지 진입시
    let name = 'Home'; // 일반 사용자
    navigationStore.isAdminView = true;
    navigationStore.isSysAdminView = to.matched.some((record) => record.meta.sysadmin); // 시스템관리자 view 체크
    navigationStore.isPartAdminView = to.matched.some((record) => record.meta.partadmin); // 담당기관관리자 view 체크

    if(isAdmin) {
      if(!isAuthenticated) {
        if (navigationStore.isPartAdminView) {
          name = 'SigninPartAdmin';
        } else if (navigationStore.isSysAdminView) {
          name = 'SigninSysAdmin';
        } else {
          name = 'SigninAdmin';
        }
        next({name: name});
      }
    }
  } else {
    navigationStore.isAdminView = false;
    navigationStore.isPartAdminView = false;
    navigationStore.isSysAdminView = false;
  }

  // console.log(to);
  // console.log(navigationStore.isAdminView);
  const num = navigationStore.isAdminView ? 1 : 0;
  // console.log(num);
  try{
    if(to.matched[0+num]) navigationStore.localNavigation.menuLevel1 = to.matched[0+num].meta.title;
    if(to.matched[1+num]) navigationStore.localNavigation.menuLevel2 = to.matched[1+num].meta.title;
    if(to.matched[2+num]) navigationStore.localNavigation.menuLevel3 = to.matched[2+num].meta.title;
    if(to.matched[3+num]) navigationStore.localNavigation.menuLevel4 = to.matched[3+num].meta.title;
  } catch(e){}
  // console.log(navigationStore.localNavigation)

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if(!isAuthenticated) {
      // console.log(to);
      navigationStore.lastAccessPage = to.fullPath;
      next({name: navigationStore.isAdminView ? 'SigninAdmin' : 'Signin'});
    } else {
      next();
    }
  } else {
    next();
  }

  setTimeout(() => {
    if(reloadFlag) {
      window.location.reload();
      reloadFlag = false;
    }
  }, 300);

  document.title = to.meta.title || '한국반도체아카데미';
  window.scrollTo(0,0);
})

export default router
